import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

// Define a type for the slice state
export interface ApplicationInvitationsSearchListTableStateState {
    TableState: string;
}

// Define the initial state using that type
const initialState: ApplicationInvitationsSearchListTableStateState = {
    TableState: JSON.stringify({ sorting: { sortModel: [{ field: "name", sort: "asc" }] } }),
};

export const applicationInvitationsSearchListTableStateSlice = createSlice({
    name: "applicationInvitationsSearchListTableState",
    initialState,
    reducers: {
        // Use the PayloadAction type to declare the contents of `action.payload`
        updateApplicationInvitationsSearchGridState: (state, action: PayloadAction<string | null>) => {
            state.TableState = action?.payload ?? initialState.TableState;
        },
    },
});

export const { updateApplicationInvitationsSearchGridState } = applicationInvitationsSearchListTableStateSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const ApplicationInvitationsSearchListTableState = (state: RootState) => state;
export default applicationInvitationsSearchListTableStateSlice.reducer;
